import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
    width: "100%",
    height: "100%",
    overflow: "hidden"
  },
  main: {
    flex: 1,
    minWidth: 0
  },
  sidebar: {
    width: 60
  }
}));

interface CommandBarContainerProps {
  main: React.ReactNode;
  sidebar: React.ReactNode;
}

const CommandBarContainer: React.FC<CommandBarContainerProps> = ({
  main,
  sidebar
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.main}>{main}</div>
      <div className={classes.sidebar}>{sidebar}</div>
    </div>
  );
};

export default CommandBarContainer;
